import FontAwesome from "../helper/font-awesome-icon";

import type { ComponentProps } from "react";
import type { IconType } from "../helper/font-awesome-icon";

type MyDivProps = ComponentProps<typeof FontAwesome>;
const Icon = (props: MyDivProps) => <FontAwesome {...props} />;

export { IconType, Icon };
